export default "__VITE_ASSET__CE8HS$k8__"